export default "/institutions/swile.svg";